export function filterObjectKeys(obj: any, keys: any, ignoreCase = false) {
  const otherObj = {};
  Object.keys(obj || {})
    .forEach((key) => {
      const normalizedKey = !ignoreCase ? key : key.toLowerCase();
      keys.forEach((innerKey: any) => {
        // eslint-disable-next-line no-param-reassign
        innerKey = !ignoreCase ? innerKey : innerKey.toLowerCase();
        if (innerKey === normalizedKey) {
          otherObj[normalizedKey] = obj[key];
        }
      });
    });

  return otherObj;
}
